export default __webpack_public_path__ + "static/media/artworks.98e996c7.svg";